import{a as e}from"./chunk-RAAYCPUM.js";function r(...n){return e(t,n)}var t=(n,o)=>n.join(o);export{r as a};
